import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=8b1e9796&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=ts"
export * from "./UserProfile.vue?vue&type=script&lang=ts"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=8b1e9796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1e9796",
  null
  
)

export default component.exports